import apiClient from './api';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
);

export const membershipAdminService = {
  getMembers: async (params = {}) => {
    const response = await apiClient.get('/api/thanhvien/manager', {
      params: cleanParams({
        search: params.search,
        trangThai: params.trangThai,
        limit: params.limit ?? 20,
        offset: params.offset ?? 0
      })
    });
    return response.data;
  },

  updateMember: async (userId, memberData) => {
    const response = await apiClient.put(`/api/thanhvien/manager/${userId}`, memberData);
    return response.data;
  },

  updateMemberStatus: async (userId, trangThai) => {
    const response = await apiClient.patch(`/api/thanhvien/manager/${userId}/status`, { trangThai });
    return response.data;
  },

  getRenewals: async (params = {}) => {
    const response = await apiClient.get('/api/thanhvien/manager/renewals', {
      params: cleanParams({
        search: params.search,
        trangThai: params.trangThai,
        limit: params.limit ?? 20,
        offset: params.offset ?? 0
      })
    });
    return response.data;
  },

  confirmCashPayment: async (registrationId, soTienNhan, ghiChu = '') => {
    const response = await apiClient.post(
      `/api/thanhvien/manager/renewals/${registrationId}/confirm-cash-payment`,
      {
        soTienNhan,
        ghiChu: ghiChu.trim() || null
      }
    );
    return response.data;
  },

  approveRenewal: async (registrationId) => {
    const response = await apiClient.post(`/api/thanhvien/manager/renewals/${registrationId}/approve`);
    return response.data;
  },

  revokeRenewalApproval: async (registrationId, lyDoHuy = '') => {
    const response = await apiClient.post(
      `/api/thanhvien/manager/renewals/${registrationId}/revoke-approval`,
      { lyDoHuy: lyDoHuy.trim() || null }
    );
    return response.data;
  },

  deleteRenewal: async (registrationId, lyDoXoa = '') => {
    const response = await apiClient.delete(`/api/thanhvien/manager/renewals/${registrationId}`, {
      data: { lyDoXoa: lyDoXoa.trim() || null }
    });
    return response.data;
  }
};
